import BronzeBadge from 'assets/images/bronze-badge.svg?react';
import GoldBadge from 'assets/images/gold-badge.svg?react';
import SilverBadge from 'assets/images/silver-badge.svg?react';
import StandardBadge from 'assets/images/standard-badge.svg?react';

export const GRADES: Record<
  string,
  {
    label: string;
    Icon: React.FC<React.SVGProps<SVGSVGElement>>;
    containerClassName: string;
    borderClassName?: string;
    labelClassName: string;
  }
> = {
  gold: {
    label: 'سطح طلایی',
    Icon: GoldBadge,
    containerClassName: 'bg-yellow-honey',
    borderClassName: 'bg-linear-to-r from-yellow-lemon via-yellow-amber to-yellow-butter p-1',
    labelClassName:
      'bg-linear-to-l from-gold-olive via-gold-bronze to-gold-wheat bg-clip-text font-bold text-transparent'
  },
  silver: {
    label: 'سطح نقره‌ای',
    Icon: SilverBadge,
    containerClassName: 'bg-silver-light',
    borderClassName: 'bg-linear-to-r from-silver-mid to-silver-pale p-1',
    labelClassName:
      'bg-linear-to-b from-silver-dark to-silver-charcoal bg-clip-text font-bold text-transparent'
  },
  bronze: {
    label: 'سطح برنزی',
    Icon: BronzeBadge,
    containerClassName: 'border-[3px] border-orange-tangerine bg-orange-peach',
    labelClassName:
      'bg-linear-to-r from-gold-olive via-gold-bronze to-gold-wheat bg-clip-text font-bold text-transparent'
  },
  standard: {
    label: 'سطح پایه',
    Icon: StandardBadge,
    containerClassName: 'bg-orange-pale',
    labelClassName: 'text-orange-vivid'
  }
};
